export default {
    fillToArtistNumb(state,data){
        state.data=data;
    }
}